import type { ComponentProps, FC } from 'react';
import { TabGroup } from '@pypestream/design-system';

/**
 * The design system's `TabGroup` registers the `onTabShow` event
 * (`ps-tab-show`) but casts its React type to the element's props only, so the
 * event isn't typed. Same component, with that event typed.
 */
export const BobcatTabGroup = TabGroup as unknown as FC<
  ComponentProps<typeof TabGroup> & {
    onTabShow?: (e: CustomEvent<{ name: string }>) => void;
  }
>;
